const index = () => {
  return <h1>Knight's Tour</h1>
}

export default index
